import { useMemo } from "react"

import { useUser } from "@clerk/nextjs"

import { hasCovalAdminAccess } from "@/utils/auth/coval-admin-access"
import { canAccessPage, getUserAccessContext } from "@/utils/auth/user-access"

export function useRestrictedAccess() {
  const { user } = useUser()

  const accessContext = useMemo(() => {
    if (!user?.primaryEmailAddress?.emailAddress) {
      return {
        isRestricted: false,
        allowedPages: [],
        allowedBasePaths: [],
        userEmail: "",
      }
    }

    const userEmail = user.primaryEmailAddress.emailAddress
    const context = getUserAccessContext({
      userId: user.id,
      userEmail,
      orgId: user.organizationMemberships?.[0]?.organization?.id || "",
      orgRole: user.organizationMemberships?.[0]?.role || "",
      orgSlug: user.organizationMemberships?.[0]?.organization?.slug || "",
      isCovalAdmin: hasCovalAdminAccess(user?.primaryEmailAddress),
      sessionToken: null,
    })

    return {
      ...context,
      userEmail,
    }
  }, [user])

  const canAccess = useMemo(() => {
    return (pagePath: string) =>
      canAccessPage(accessContext.userEmail, pagePath)
  }, [accessContext.userEmail])

  return {
    ...accessContext,
    canAccess,
  }
}
